const ROUTE_SCREEN_NAMES = {
  "/dashboard": "Doctor Dashboard",
  "/dr-round": "Dr. Round",
  "/ot-note": "OT Note",
  "/discharge-summary": "Discharge Summary",
  "/medical-records": "Medical Records",
  "/case-paper": "Case Paper",
  "/bed-view": "Bed View",
  "/pathology-result-approval": "Pathology Result Approval / Modification",
  "/purchase-order-approval": "Purchase Order Approval",
  "/intake-output-chart": "Intake Output Chart",
  "/tpr": "TPR",
  "/nursing-notes": "Nursing Notes",
  "/rmo-notes": "RMO Notes",
};

export const getScreenNameForPath = (path) => ROUTE_SCREEN_NAMES[path] || null;

export const recordScreenVisit = () => {};
